import { get } from 'lodash'
import { createSelector } from 'reselect'
import { LEVELS } from 'constants/enums'

const hasGoldAward = awards => {
  return awards.some(
    award => get(award, 'awardLevel.value') === LEVELS.GOLD.value
  )
}

export default createSelector(awards => awards, hasGoldAward)
